import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { IFlightSearchRequest } from 'src/app/models/request/IRequest';
import { IFlightDeepLinkResponse } from 'src/app/models/response/flight-deeplink.response';
import { IFlightJourneys } from 'src/app/models/response/flight.response';
import { AuthService, HttpService, LoaderService, UtilityService } from 'src/app/services';
import { CryptoService } from 'src/app/services/crypto.service';
import { MatDialog } from '@angular/material/dialog';
import { TemplateRef, ViewChild } from '@angular/core';
import { EventService } from 'src/app/services/event.service';
import { FlightService } from 'src/app/services/flight.service';
@Component({
  selector: 'app-flight-itinerary',
  templateUrl: './flight-itinerary.component.html',
  styleUrls: ['./flight-itinerary.component.scss']
})
export class FlightItineraryComponent implements OnInit, OnChanges {

  @Input() flightjourneys: IFlightJourneys[] = [];
  @Input() flightSearchRequest: IFlightSearchRequest;
  selectedItem;
  isAsc: boolean = true;
  isDuration: boolean = true;
  isArrive: boolean = true;
  isDepart: boolean = true
  morefare: any = [];
  flight_Details: any[] = [];
  moretext: any = 'More Fares';
  supersve: boolean = true;
  supersve1: boolean = false;
  flexi: boolean = false;
  flexi1: boolean = true;
  easy: boolean = false;
  easy1: boolean = true;



  ticon: boolean = true;
  tflex: boolean = false;
  teasy: boolean = false;

  isLoaded: boolean = false
  selectedPriceType: string = 'superSaver';


  constructor(
    private cryptoService: CryptoService,
    private router: Router,
    private route: ActivatedRoute,
    private flight: FlightService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    public loaderService: LoaderService,
    private eventService: EventService,
    public utilities: UtilityService,
    private authService: AuthService,

  ) { }

  ngOnInit(): void {
    this.eventService.subscribe('flight-result', (res) => {
      if (res) {
        this.isLoaded = res
      }
    }
    )
  }

  ngOnChanges(): void {
  }


  select(item) {
    this.selectedItem = item;
  }

  showFlightDetails(i) {
    this.flight_Details[i] = !this.flight_Details[i]

  }

  selectgreen1() {

    this.supersve = !this.supersve;
    this.supersve1 = !this.supersve1;

  }
  selectgreen2() {

    this.flexi = !this.flexi;
    this.flexi1 = !this.flexi1;

  }
  selectgreen3() {

    this.easy = !this.easy;
    this.easy1 = !this.easy1;

  }
  shoeMorefare(i: any) {
    this.morefare[i] = !this.morefare[i];
  }


  sortByDepart() {
    this.isDepart = !this.isDepart
    this.flightjourneys = this.flightjourneys.sort(
      (a: IFlightJourneys, b: IFlightJourneys) =>
        this.isDepart ?
          a.flightlegs[0][0].deptime.localeCompare(b.flightlegs[0][0].deptime) :
          b.flightlegs[0][0].deptime.localeCompare(a.flightlegs[0][0].deptime)
    )
  }

  sortByArrive() {
    this.isArrive = !this.isArrive
    this.flightjourneys = this.flightjourneys.sort(
      (a: IFlightJourneys, b: IFlightJourneys) =>
        this.isArrive ?
          a.flightlegs[0][a.flightlegs[0].length - 1].arrtime.localeCompare(b.flightlegs[0][b.flightlegs[0].length - 1].arrtime) :
          b.flightlegs[0][b.flightlegs[0].length - 1].arrtime.localeCompare(a.flightlegs[0][a.flightlegs[0].length - 1].arrtime)
    )
  }
  sortByDuration() {
    this.isDuration = !this.isDuration
    this.flightjourneys = this.flightjourneys.sort(
      (a: IFlightJourneys, b: IFlightJourneys) =>
        this.isDuration ? a.totaljourneyduration - b.totaljourneyduration : b.totaljourneyduration - a.totaljourneyduration
    )

  }
  sortByPrice() {
    this.isAsc = !this.isAsc;
    this.flightjourneys = this.flightjourneys.sort(
      (a: IFlightJourneys, b: IFlightJourneys) =>
        this.isAsc ? a.flightfare.totalnet - b.flightfare.totalnet : b.flightfare.totalnet - a.flightfare.totalnet)
  }

  bookFlight(item: IFlightJourneys) {
    if (!localStorage.getItem('priceType')) {
      this.togglePrice('superSaver')
    }

    this.flight.getBookingIdFromDeepLink(item.flightdeeplinkurl).subscribe((res: IFlightDeepLinkResponse) => {
      if (res && res.booking_id) {
        const flightDetail = this.cryptoService.encrypt(JSON.stringify(item));
        const bookingId = this.cryptoService.encrypt(res.booking_id);
        const passengerRules = this.cryptoService.encrypt(JSON.stringify(res.passenger_rules));
        const flightType = this.cryptoService.encrypt('one_way');
        const flightSearchRequest = this.cryptoService.encrypt(JSON.stringify(this.flightSearchRequest));
        localStorage.setItem('FlightRoundTrip__', JSON.stringify([item]));
        localStorage.setItem('flightDetail', flightDetail);
        localStorage.setItem('bookingId', bookingId);
        localStorage.setItem('flightType', flightType);
        localStorage.setItem('flightSearchRequest', flightSearchRequest);
        localStorage.setItem('passengerRules', passengerRules);
        if(this.authService.loggedIn()) {
          this.router.navigate([`/u/flights/booking/${res.booking_id}`]);
        } else {
          this.router.navigate([`/booking/${res.booking_id}`]);
        }

      } else {
        this.snackbar.open('Something went wrong.', 'Error', {
          duration: 3000,
          panelClass: ['loginError'],
          horizontalPosition: 'end',
          verticalPosition: 'top',
        });
      }
    })
  }

  togglePrice(priceType: string) {
    this.selectedPriceType = priceType;
    localStorage.setItem('priceType', priceType);
  }

  toggleicons() {
    this.ticon = !this.ticon;
    this.tflex = false;
    this.teasy = false;
  }

  toggleicons1() {
    this.ticon = false;
    this.tflex = !this.tflex;
    this.teasy = false;
  }

  toggleicons2() {
    this.ticon = false;
    this.tflex = false;
    this.teasy = !this.teasy;
  }



}
